export type ParsedDeepLink =
  | { kind: 'publicShare'; publicLinkId: string }
  | { kind: 'addTrove'; url: string }
  | { kind: 'newNote'; body: string; title?: string }
  | { kind: 'session'; sessionId: string };

function firstQueryString(v: string | null): string {
  return v?.trim() ?? '';
}

/**
 * Parse trove:// deep links for desktop (mirrors trove-mobile/services/deepLinks.ts).
 */
export function parseDeepLink(url: string | null | undefined): ParsedDeepLink | null {
  if (!url) return null;
  try {
    const normalized = url.replace(/^trove:\/\//i, 'https://trove.local/');
    const parsed = new URL(normalized);
    const qp = parsed.searchParams;
    const pathParts = parsed.pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);
    const hostPart = parsed.hostname && parsed.hostname !== 'trove.local' ? parsed.hostname : '';
    const head = (pathParts[0] ?? hostPart).toLowerCase();

    if (head === 'add') {
      const targetUrl = firstQueryString(qp.get('url'));
      if (targetUrl) return { kind: 'addTrove', url: targetUrl };
    }

    if (head === 'note') {
      const body = qp.get('body') ?? '';
      if (body.trim()) {
        return {
          kind: 'newNote',
          body,
          title: firstQueryString(qp.get('title')) || undefined,
        };
      }
    }

    if (head === 'session' && pathParts[1]) {
      return { kind: 'session', sessionId: pathParts[1] };
    }

    if (head === 't' && pathParts[1]) {
      return { kind: 'publicShare', publicLinkId: pathParts[1] };
    }
  } catch {
    // ignore malformed URLs
  }
  return null;
}

export function deepLinkToRoute(parsed: ParsedDeepLink): string {
  switch (parsed.kind) {
    case 'addTrove':
      return `/bookmarks?addUrl=${encodeURIComponent(parsed.url)}`;
    case 'newNote':
      return `/notes/new?body=${encodeURIComponent(parsed.body)}${
        parsed.title ? `&title=${encodeURIComponent(parsed.title)}` : ''
      }`;
    case 'publicShare':
      return `/t/${encodeURIComponent(parsed.publicLinkId)}`;
    case 'session':
      return `/tabs/${encodeURIComponent(parsed.sessionId)}/list`;
    default:
      return '/';
  }
}
